import Vue from "vue";
import Vuex from "vuex";
import Login from "./Credentials/login";
import sidenav from "./Layouts/sidenav";
import dialog from "./Layouts/dialogs";
import DropDownUser from "@/store/Main/DropDowns";
import MainCountries from "@/store/modules/main/Countries";
import MasterDataUsers from "@/store/modules/MasterData/users";
import MasterDataDepartment from "@/store/modules/MasterData/department";
import MasterDataDepartmentAccess from "@/store/modules/MasterData/departmentaccess";
import MasterDataRoles from "@/store/modules/MasterData/roles";
import MasterDataSalesman from "@/store/modules/MasterData/salesman";
import MasterDataCustomer from "@/store/modules/MasterData/customer";
import MasterDataVendor from "@/store/modules/MasterData/vendor";
import ItStockAdjustment from "@/store/modules/it/stock-adjustment";
import Items from "@/store/modules/Sales/Items/Items";
import SalesReports from "@/store/modules/Reports/SalesReports/index";
import AcctItemCosting from "@/store/modules/Accounting/ItemCosting/ItemCosting";
import AcctStatementOfAccount from "@/store/modules/Accounting/StatementOfAccount/StatementOfAccount";
import AcctCreditMemo from "@/store/modules/Accounting/CreditMemo/CreditMemo";
import accounting from "@/store/modules/Accounting/accounting";
import Payments from "@/store/modules/Accounting/Payments/Payments";
import SystemSettings from "@/store/Main/SystemSettings/index";
import Promos from "@/store/modules/Sales/Promos/Promos";
import salesOrder from "@/store/modules/Sales/SalesOrder/index";
import PL from "@/store/modules/Sales/PackingList/packing-list";
import salesquotation from "@/store/modules/Sales/SalesQuotations/SalesQuotations";
import inventory from "@/store/modules/Operations/index";
import AccountingBanks from "@/store/modules/Accounting/Banks/Banks";
import WarehouseReturn from "@/store/modules/Operations/WarehouseReturn/WarehouseReturn";
import AcctCreditMemoHistory from "@/store/modules/Accounting/CreditMemoHistory/CreditMemoHistory";
import PackingListHistory from "@/store/modules/Accounting/PackingListHistory/PackingListHistory";
import AccountsPayable from "@/store/modules/Accounting/AccountsPayable/AccountsPayable";
import GeneralSettings from "@/store/Main/SystemSettings/GeneralSettings";
import CustomerAccessSettings from "@/store/Main/SystemSettings/customerAccessSettings";
import Camera from "@/store/Layouts/camera";
import Companies from "@/store/modules/MasterData/companies";
import reportmodule from "@/store/modules/MasterData/reportmodule";
import DebitMemoHistory from "@/store/modules/Accounting/DebitMemooHistory/DebitMemoHistory";
import LeaveApplication from "@/store/modules/HR/LeaveApplication/LeaveApplication";
import AppNotifications from "@/store/Layouts/notifications";
import AppReminders from "@/store/Layouts/reminders";
import NotificationSettingsStore from "@/store/Main/notificationSettings";
import UserProfileStore from "@/store/Main/userProfile";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: false,
  modules: {
    Login,
    sidenav,
    MasterDataUsers,
    MasterDataDepartment,
    MasterDataDepartmentAccess,
    MasterDataRoles,
    MasterDataSalesman,
    DropDownUser,
    MasterDataCustomer,
    MasterDataVendor,
    MainCountries,
    ItStockAdjustment,
    dialog,
    Items,
    SalesReports,
    AcctItemCosting,
    AcctStatementOfAccount,
    AcctCreditMemo,
    accounting,
    Payments,
    SystemSettings,
    Promos,
    salesOrder,
    PL,
    salesquotation,
    AccountingBanks,
    WarehouseReturn,
    inventory,
    AccountsPayable,
    AcctCreditMemoHistory,
    GeneralSettings,
    CustomerAccessSettings,
    Camera,
    PackingListHistory,
    Companies,
    reportmodule,
    DebitMemoHistory,
    LeaveApplication,
    AppNotifications,
    AppReminders,
    NotificationSettingsStore,
    UserProfileStore,
  },
});
